import axiosClient from "..";
import { getErrorMessageObj } from "../../../container/SportsBookNode/utils/common/functions";

export default class MatchService {
  static getMatches(payload) {
    !payload.search && delete payload.search;
    if (payload?.sportCountryId === "all") delete payload.sportCountryId;
    if (payload?.countryId === "all") delete payload.countryId;
    return axiosClient
      .get("/sb/eventList", {
        params: {
          ...payload
        }
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        return getErrorMessageObj(error);
      });
  }
}
